import { RootState } from '../../store';

export const getCategories = (state: RootState) => state.categories.categories;

export const getSubcategories = (state: RootState) =>
  state.categories.subcategories;

export const getCurrentCategoryId = (state: RootState) =>
  state.categories.currentCategoryId;
export const getSelectedCategories = (state: RootState) =>
  state.categories.selectedCategories;
